let teamMembers = '';

export default function () {
  teamMembers = document.querySelectorAll('.team-tile');
  if (teamMembers) {

    const observerConfig = {
      rootMargin: '0% 0% -25% 0%',
      threshold: 0.05
    };

    const observer = new IntersectionObserver( function(entries) {
      entries.forEach(function(entry) {
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, observerConfig);

    teamMembers.forEach( function(block) {
      observer.observe(block);
    });

  }
}
